import React, { useContext } from "react";
import _ from "lodash";
import {
  Badge,
  Button,
  LegacyCard as Card,
  Text,
  Link,
  InlineStack,
  Thumbnail,
  Box,
  BlockStack,
  Divider,
} from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";
import { PrivateContext } from "lib/context";
import { OrderContext } from "app/orders/modules/provider/features/view/orderContext";
import constant from "lib/constant/constant";
import { statusHelper, baseHelper, imageHelper } from "lib/helpers";
import LineItemProperties from "app/orders/modules/generic/service/lineItemProperties";
import { StyledCard } from "app/orders/modules/operator/features/view/genericStyled";
import { useNavigate, useParams } from "react-router-dom";

const FulfilledLineItems = (props) => {
  const { data, fulfilledData, getSlipText, lineItemArray, packingSlipAccessData, setFulfillAmount } = props;
  const { cms, userData } = useContext(PrivateContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    setAddressId,
    fulfillmentType: orderFulfillmentType,
    setFulfillmentType: setOrderFulfillmentType,
  } = useContext(OrderContext);
  const { PARTIAL, FULFILLED, REFUND } = constant;
  const currentUserData = baseHelper.getResponseData(userData, constant.gql.GET_CURRENT_USER);

  const amount = [];
  const vendorsSum = [];
  let countItems = 0;

  fulfilledData &&
    fulfilledData.length &&
    fulfilledData.forEach((dataLine) => {
      const { totalPrice = 0, vendor } = dataLine;
      vendorsSum.push(vendor);
      amount.push(totalPrice);
      countItems += 1;
      return [amount];
    });

  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;

  const stringToNumber = amount.map((item) => parseFloat(item));
  const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);
  if (totalAmount) {
    setFulfillAmount(totalAmount);
  }

  const isVendor = baseHelper.isVendor(currentUserData);

  const lineItems = fulfilledData.map((lineItem, idx) => {
    const {
      id: shopifyLineItemId = "",
      name = "",
      sku,
      totalPrice,
      totalQuantity,
      // fulfillmentStatus,
      fulfillmentType,
    } = lineItem || {};
    const getItem = lineItemArray.find((item) => item.shopifyLineItemId === shopifyLineItemId);
    const {
      fulfillmentStatus,
      image = "",
      isProductDeleted,
      isVendorDeleted,
      moneyFormat: lineMoneyFormat,
      productId,
      rejectedByVendor = false,
      vendor,
      vendorId,
      properties,
    } = getItem || {};

    const lineItemKey = `lineItem${idx}`;
    const lineImage = imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;
    const typeValue = getItem && getItem.fulfillmentType;
    const typeData = orderFulfillmentType;
    if (typeData && _.isArray(typeData) && typeValue && !typeData.includes(typeValue)) {
      typeData.push(typeValue);
    }
    setOrderFulfillmentType(typeData);
    if (typeValue === constant.CONSIGNMENT) {
      setAddressId((getItem && getItem.addressId) || "");
    }

    const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;
    const isServiceLineItem = baseHelper.isServiceLineItem(typeValue, properties);
    const status = statusHelper.getBadgeStatus(
      isServiceLineItem ? constant.COMPLETED : rejectedByVendor ? constant.FULFILLED_BY_OPERATOR : constant.FULFILLED
    );
    const badgeType = baseHelper.getBadgeType(constant.FULFILLED);
    const productURL = isServiceLineItem ? `/products/service/edit/${productId}` : `/products/edit/${productId}`;

    const lineItemName = <div className="productName">{name}</div>;

    return (
      <div key={lineItemKey} className="fulfilled-Secn">
        <Box padding={"400"}>
          <InlineStack wrap={false} align="space-between">
            <InlineStack wrap={false} gap={"400"}>
              <Thumbnail size="large" source={lineImage} alt={name} />
              <BlockStack gap={"100"}>
                {(isProductDeleted && (lineItemName || "")) || (
                  <Link onClick={() => navigate(productURL)}>{lineItem.name || ""}</Link>
                )}

                <BlockStack gap={"100"}>
                  <LineItemProperties
                    variation={constant.SUBDUED}
                    properties={properties}
                    isServiceLineItem={isServiceLineItem}
                  />
                  <Text as="span" variant="bodySm" tone={constant.SUBDUED}>
                    {vendor && vendorId && `${cms("label.vendor")}: ${vendor}`}
                  </Text>
                  {isServiceLineItem ? (
                    ""
                  ) : (
                    <Text as="span" variant="bodySm" tone={constant.SUBDUED}>
                      {cms("label.skuList")} {sku}
                    </Text>
                  )}
                </BlockStack>
                <InlineStack gap={"400"} blockAlign="center">
                  <Badge tone={badgeType} className="text-capitalize">
                    {status}
                  </Badge>
                  {rejectedByVendor && (
                    <Badge tone={baseHelper.getBadgeType(constant.REJECTED)} className="text-capitalize">
                      {constant.REJECTED}
                    </Badge>
                  )}
                  {!(fulfillmentStatus === constant.REFUND) && (
                    <span className="packing-slip-link">
                      {[FULFILLED, PARTIAL, REFUND].includes(fulfillmentStatus) &&
                        (packingSlipAccessData.isEnabled ||
                          !(
                            packingSlipAccessData.isAllVendor ||
                            (packingSlipAccessData.selectedVendor &&
                              packingSlipAccessData.selectedVendor.includes(vendorId))
                          )) && (
                          <Button variant="plain" icon={NoteIcon} onClick={() => window.open(`/order-slip/${id}`)}>
                            {getSlipText(fulfillmentType)}
                          </Button>
                        )}
                    </span>
                  )}
                </InlineStack>
              </BlockStack>
            </InlineStack>
            <InlineStack gap={"400"}>
              <Text as="span">
                {`${cms("label.qty")}:`}
                {totalQuantity}
              </Text>
              <Text as="span">
                {moneyFormat}
                {(totalPrice && totalPrice.toFixed(2)) || constant.value.ZERO}
              </Text>
            </InlineStack>
          </InlineStack>
        </Box>
      </div>
    );
  });
  const moneyFormat = data && data.moneyFormat;
  const totalFulfill = (
    <>
      <Divider />
      <Box padding={"400"}>
        <InlineStack align="space-between">
          <Text as="span" fontWeight="semibold">
            {cms("label.total")}
          </Text>
          <InlineStack gap={"400"}>
            <Text variant="bodySm" as="p">
              {" "}
              (
              {countItems > 1
                ? `${countItems}
                ${cms("label.items")} from ${addVendorTxt}`
                : `${countItems}
                ${cms("label.item")} from ${addVendorTxt}`}
              )
            </Text>
            <Text as="span" fontWeight="semibold">
              {`${moneyFormat || constant.symbol.DOLLAR}${totalAmount.toFixed(2)}`}
            </Text>
          </InlineStack>
        </InlineStack>
      </Box>
    </>
  );
  return [lineItems, totalFulfill];
};

export default FulfilledLineItems;
